import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import axios from 'axios'
Vue.prototype.$http = axios;
Vue.use(preview, {
  fullscreenEl:false, //关闭全屏按钮
  tapToClose: true,
})
import waterfall from "vue-waterfall2";
Vue.use(waterfall);

import Component from './Component.vue'
if (window.Vue) {
  Vue.component(require('../schema.json').type, Component)
}
export default Component
